import { ColorScheme } from '../color.interface';

/**
 * Excel color scheme.
 */
export const COLOR_SCHEME_CLUSTERS: ColorScheme = [
  {
    displayName: null,
    hex: '#aa3d95',
    languages: [
      { language: 'nl', displayName: 'Paars' },
      { language: 'en', displayName: 'Purple' }
    ]
  },
  {
    displayName: null,
    hex: '#6c3e96',
    languages: [
      { language: 'nl', displayName: 'Violet' },
      { language: 'en', displayName: 'Violet' }
    ]
  },
  {
    displayName: null,
    hex: '#48469c',
    languages: [
      { language: 'nl', displayName: 'Donkerblauw' },
      { language: 'en', displayName: 'Dark blue' }
    ]
  },
  {
    displayName: null,
    hex: '#0070ba',
    languages: [
      { language: 'nl', displayName: 'Blauw' },
      { language: 'en', displayName: 'Blue' }
    ]
  },
  {
    displayName: null,
    hex: '#00a89c',
    languages: [
      { language: 'nl', displayName: 'Groenblauw' },
      { language: 'en', displayName: 'Teal' }
    ]
  },
  {
    displayName: null,
    hex: '#50b747',
    languages: [
      { language: 'nl', displayName: 'Groen' },
      { language: 'en', displayName: 'Green' }
    ]
  },
  {
    displayName: null,
    hex: '#b1d235',
    languages: [
      { language: 'nl', displayName: 'Lichtgroen' },
      { language: 'en', displayName: 'Light green' }
    ]
  },
  {
    displayName: null,
    hex: '#ffe600',
    languages: [
      { language: 'nl', displayName: 'Geel' },
      { language: 'en', displayName: 'Geel' }
    ]
  },
  {
    displayName: null,
    hex: '#f4811f',
    languages: [
      { language: 'nl', displayName: 'Oranje' },
      { language: 'en', displayName: 'Orange' }
    ]
  },
  {
    displayName: null,
    hex: '#eb1b2d',
    languages: [
      { language: 'nl', displayName: 'Rood' },
      { language: 'en', displayName: 'Red' }
    ]
  },
];
